/* eslint-disable import/no-anonymous-default-export */
import { getRehydratableName } from '@dcl/ui';

//  this file runs dynamic imports and immediately calls on the rehydrator function
//  this is not testable
//
//  we should break this process down in order to also test dynamic imports
//
//  this file should be dedicated to generating the dynamic `import()` and
//  getting the `rehydrator` func from the module object
//
//  tests should be written to ensure that a `rehydrator` is returned
//
//  we can offload wrapping the rehydrator into the `react-from-markup` spec in a file
//  supplying `renderBrowser`
//
//  1. `() => import -> rehydratorGetter`
//   - test all the registered rehydrateFn are defined
//  2. iterate to wrap to expose to `react-from-markup` and `renderBrowser`
//

export default {
  // @ts-ignore
  [getRehydratableName('AnnotatedScreenshot')]: (...args) =>
    import('@dcl/ui/esm/fragments/AnnotatedScreenshot').then((Component) =>
      Component.rehydrator(
        // @ts-ignore
        ...args
      )
    ),
  // @ts-ignore
  [getRehydratableName('Carousel')]: (...args) =>
    // @ts-ignore
    import('@dcl/ui/esm/modules/Carousel').then((carouselComponent) =>
      carouselComponent.rehydrator(
        // @ts-ignore
        ...args
      )
    ),
  // @ts-ignore
  [getRehydratableName('DismissibleBanner')]: (...args) =>
    import('@dcl/ui/esm/fragments/DismissibleBanner').then(
      (dismissibleBannerComponent) =>
        dismissibleBannerComponent.rehydrator(
          // @ts-ignore
          ...args
        )
    ),
  // @ts-ignore
  [getRehydratableName('Dropdown')]: (...args) =>
    import('@dcl/ui/esm/modules/Dropdown').then((dropDownComponent) =>
      dropDownComponent.rehydrator(
        // @ts-ignore
        ...args
      )
    ),
  // @ts-ignore
  [getRehydratableName('Expandable.Item')]: (...args) =>
    import('@dcl/ui/esm/modules/Expandable').then((expandableComponent) =>
      expandableComponent.rehydrator(
        // @ts-ignore
        ...args
      )
    ),
  // @ts-ignore
  [getRehydratableName('FlexGrid')]: (...args) =>
    import('@dcl/ui/esm/modules/FlexGrid').then((flexGridComponent) =>
      flexGridComponent.rehydrator(
        // @ts-ignore
        ...args
      )
    ),
  // @ts-ignore
  [getRehydratableName('FlexGrid.Row')]: (...args) =>
    import('@dcl/ui/esm/modules/FlexGrid/components/Row').then(
      (flexGridRowComponent) =>
        flexGridRowComponent.rehydrator(
          // @ts-ignore
          ...args
        )
    ),
  // @ts-ignore
  [getRehydratableName('FlexGrid.Col')]: (...args) =>
    import('@dcl/ui/esm/modules/FlexGrid/components/Col').then(
      (flexGridColComponent) =>
        flexGridColComponent.rehydrator(
          // @ts-ignore
          ...args
        )
    ),
  // @ts-ignore
  [getRehydratableName('GlobalFooter')]: (...args) =>
    // @ts-ignore
    import('@dcl/ui/esm/fragments/GlobalFooter').then((globalFooterComponent) =>
      // @ts-ignore
      globalFooterComponent.rehydrator(...args)
    ),
  // @ts-ignore
  [getRehydratableName('GlobalHeader')]: async (...args) =>
    // @ts-ignore
    (await import('@dcl/ui/esm/fragments/GlobalHeader')).rehydrator(...args),
  // @ts-ignore
  [getRehydratableName('GlobalHeader.BaseItem')]: async (...args) =>
    // @ts-ignore
    (await import('@dcl/ui/esm/fragments/GlobalHeader')).baseItemRehydrator(
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('GlobalHeader.Cart')]: async (...args) =>
    // @ts-ignore
    (await import('@dcl/ui/esm/fragments/GlobalHeader')).cartRehydrator(
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('GlobalHeader.Login')]: async (...args) =>
    // @ts-ignore
    (await import('@dcl/ui/esm/fragments/GlobalHeader')).loginRehydrator(
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('Figure')]: (...args) =>
    import('@dcl/ui/esm/fragments/Figure').then((figureComponent) =>
      // @ts-ignore
      figureComponent.rehydrator(...args)
    ),
  // @ts-ignore
  [getRehydratableName('FilteredList')]: (...args) =>
    import('@dcl/ui/esm/fragments/FilteredList').then((filteredListComponent) =>
      // @ts-ignore
      filteredListComponent.rehydrator(...args)
    ),
  // @ts-ignore
  [getRehydratableName('FilteredList.ListItem')]: (...args) =>
    import('@dcl/ui/esm/fragments/FilteredList').then((filteredListComponent) =>
      // @ts-ignore
      filteredListComponent.listItemRehydrator(...args)
    ),
  // @ts-ignore
  [getRehydratableName('Form')]: async (...args) =>
    // @ts-ignore
    (await import('@dcl/ui/esm/fragments/Form')).formRehydrator(...args),
  // @ts-ignore
  [getRehydratableName('Form.SelectControl')]: async (...args) =>
    // @ts-ignore
    (await import('@dcl/ui/esm/fragments/Form/components/SelectControl'))
      // @ts-ignore
      .rehydrator(...args),
  // @ts-ignore
  [getRehydratableName('Form.CampaignControl')]: async (...args) =>
    // @ts-ignore
    (await import('@dcl/ui/esm/fragments/Form')).campaignControlRehydrator(
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('Form.PrivacyControl')]: async (...args) =>
    // @ts-ignore
    (await import('@dcl/ui/esm/fragments/Form')).privacyControlRehydrator(
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('HorizontalOverflow')]: async (...args) =>
    // @ts-ignore
    (await import('@dcl/ui/esm/modules/HorizontalOverflow')).rehydrator(
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('Longform.ChapterNavInner')]: async (...args) =>
    // @ts-ignore
    (await import('@dcl/ui/esm/modules/Longform')).chapterNavRehydrator(
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('Longform.ChapterNav.Chapter')]: async (...args) =>
    // @ts-ignore
    (await import('@dcl/ui/esm/modules/Longform')).chapterNavChapterRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('PageNavInner')]: (...args) =>
    import('@dcl/ui/esm/fragments/PageNav').then((pageNavInnerComponent) =>
      pageNavInnerComponent.rehydrator(
        // @ts-ignore
        ...args
      )
    ),
  // @ts-ignore
  [getRehydratableName('PageNav.Item')]: (...args) =>
    import('@dcl/ui/esm/fragments/PageNav').then((pageNavComponent) =>
      pageNavComponent.itemRehydrator(
        // @ts-ignore
        ...args
      )
    ),
  // @ts-ignore
  [getRehydratableName('SearchFilters.Filters')]: async (...args) =>
    (await import('@dcl/ui/esm/elements/SearchFilters')).filtersRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('Popover')]: async (...args) =>
    (await import('@dcl/ui/esm/modules/Popover')).rehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('ProductDetail')]: async (...args) =>
    // @ts-ignore
    (await import('@dcl/ui/esm/fragments/ProductDetail')).rehydrator(...args),
  // @ts-ignore
  [getRehydratableName('SearchFilters.FilterSectionOverflow')]: async (
    // @ts-ignore
    ...args
  ) =>
    (
      await import('@dcl/ui/esm/elements/SearchFilters')
    ).filterSectionOverflowRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('SearchFilters.Selected')]: async (...args) =>
    (await import('@dcl/ui/esm/elements/SearchFilters')).selectedReyhdrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('SearchInput')]: async (...args) =>
    // @ts-ignore
    (await import('@dcl/ui/esm/elements/SearchInput')).rehydrator(...args),
  // @ts-ignore
  [getRehydratableName('ShowMore')]: (...args) =>
    import('@dcl/ui/esm/fragments/ShowMore').then((showMoreComponent) =>
      // @ts-ignore
      showMoreComponent.rehydrator(...args)
    ),
  // @ts-ignore
  [getRehydratableName('SiteFooter')]: async (...args) =>
    // @ts-ignore
    (await import('@dcl/ui/esm/fragments/SiteFooter')).rehydrator(...args),
  // @ts-ignore
  [getRehydratableName('SiteFooter.NavList')]: async (...args) =>
    (await import('@dcl/ui/esm/fragments/SiteFooter')).navListRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('SiteHeader')]: async (...args) =>
    (await import('@dcl/ui/esm/fragments/SiteHeader')).rehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('SiteHeader.Menu')]: async (...args) =>
    (await import('@dcl/ui/esm/fragments/SiteHeader')).menuRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('SiteHeaderFlyouts')]: async (...args) =>
    (await import('@dcl/ui/esm/fragments/SiteHeader')).flyoutsRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('SiteHeader.Flyouts.TabPanel')]: async (...args) =>
    (await import('@dcl/ui/esm/fragments/SiteHeader')).flyoutsPanelRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('TableWithFilters')]: async (...args) =>
    // @ts-ignore
    (await import('@dcl/ui/esm/fragments/TableWithFilters')).rehydrator(
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('Tabs')]: async (...args) =>
    // @ts-ignore
    (await import('@dcl/ui/esm/fragments/Tabs')).rehydrator(...args),
  // @ts-ignore
  [getRehydratableName('Tabs.Panel')]: async (...args) =>
    // @ts-ignore
    (await import('@dcl/ui/esm/fragments/Tabs')).panelRehydrator(...args),
  // @ts-ignore
  [getRehydratableName('TabsAdvanced')]: async (...args) =>
    // @ts-ignore
    (await import('@dcl/ui/esm/fragments/TabsAdvanced')).rehydrator(...args),
  // @ts-ignore
  [getRehydratableName('Ticker')]: async (...args) =>
    // @ts-ignore
    (await import('@dcl/ui/esm/modules/Ticker')).rehydrator(...args),
  // @ts-ignore
  [getRehydratableName('Ticker.Item')]: async (...args) =>
    // @ts-ignore
    (await import('@dcl/ui/esm/modules/Ticker')).itemRehydrator(...args),
  // @ts-ignore
  [getRehydratableName('TwitterCardTimeline')]: (...args) =>
    // @ts-ignore
    import('@dcl/ui/esm/fragments/Card').then((Component) =>
      // @ts-ignore
      Component.twitterCardTimelineRehydrator(...args)
    ),
  // @ts-ignore
  [getRehydratableName('VideoPlayerCore')]: async (...args) =>
    (await import('@dcl/ui/esm/fragments/VideoPlayer')).rehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('VideoPlayerCore')]: async (...args) =>
    // @ts-ignore
    (await import('@dcl/ui/esm/fragments/VideoPlayer')).rehydrator(...args),
  // @ts-ignore
  [getRehydratableName('CoveoSearchBox')]: async (...args) =>
    (
      await import('@dcl/ui/esm/fragments/CoveoSearch/CoveoSearchBox')
    ).rehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('CoveoSearchResult')]: async (...args) =>
    (
      await import('@dcl/ui/esm/fragments/CoveoSearch/CoveoSearchResult')
    ).rehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('BrowseExperienceBanner')]: async (...args) =>
    (
      await import('../components/BrowseExperienceBanner')
    ).BrowseExperienceBannerRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('ChatWithUs')]: async (...args) =>
    (await import('../components/ChatWithUs')).ChatWithUsRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('CiamLogin')]: async (...args) =>
    (await import('../components/CiamLogin')).CiamLoginRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('ClickablePhoneNumber')]: async (...args) =>
    (
      await import('../components/ClickablePhoneNumber')
    ).ClickablePhoneNumberRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('CommunityBanner')]: async (...args) =>
    (await import('../components/CommunityBanner')).CommunityBannerRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('ContactUs')]: async (...args) =>
    (await import('../components/ContactUs')).ContactUsRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('ContactUsHeader')]: async (...args) =>
    (await import('../components/ContactUsHeader')).ContactUsHeaderRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('CopyLink')]: async (...args) =>
    (await import('../components/CopyLink')).CopyLinkrRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('EmailArticle')]: async (...args) =>
    (await import('../components/EmailArticle')).EmailRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('EmailUs')]: async (...args) =>
    (await import('../components/EmailUs')).EmailUsRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('FrequentlyAskedQuestions')]: async (...args) =>
    (
      await import('../components/FrequentlyAskedQuestions')
    ).FrequentlyAskedQuestionsRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('HelpCenterSpacer')]: async (...args) =>
    (await import('../components/HelpCenterSpacer')).HelpCenterSpacerRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('LanguageSelector')]: async (...args) =>
    (await import('../components/LanguageSelector')).LanguageSelectorRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('PageNotFound')]: async (...args) =>
    (await import('../components/PageNotFound')).PageNotFoundRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('ProductSelection')]: async (...args) =>
    (await import('../components/ProductSelection')).ProductSelectionRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('SearchHelpTopics')]: async (...args) =>
    (await import('../components/SearchHelpTopics')).SearchHelpTopicsRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('SupportTicket')]: async (...args) =>
    (await import('../components/SupportTicket')).SupportTicketRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('TalkWithUs')]: async (...args) =>
    (await import('../components/TalkWithUs')).TalkWithUsRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('TermsAndConditions')]: async (...args) =>
    (
      await import('../components/TermsAndConditions')
    ).TermsAndConditionsRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('TrainingExperienceVideos')]: async (...args) =>
    (
      await import('../components/TrainingExperienceVideos')
    ).TrainingExperienceVideosRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('UltraTaxCS')]: async (...args) =>
    (await import('../components/UltraTaxCS')).UltraTaxCSRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('FileDownloadExperience')]: async (...args) =>
    (
      await import('../components/FileDownloadExperience')
    ).FileDownloadExperienceRehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('CoveoSearchBox')]: async (...args) =>
    (
      await import('@dcl/ui/esm/fragments/CoveoSearch/CoveoSearchBox')
    ).rehydrator(
      // @ts-ignore
      ...args
    ),
  // @ts-ignore
  [getRehydratableName('CoveoSearchResult')]: async (...args) =>
    (
      await import('@dcl/ui/esm/fragments/CoveoSearch/CoveoSearchResult')
    ).rehydrator(
      // @ts-ignore
      ...args
    ),
  [getRehydratableName('BackToTop')]: async (...args) =>
    (await import('../components/BackToTop')).BackToTopRehydrator(
      // @ts-ignore
      ...args
    ),
  [getRehydratableName('CiamError')]: async (...args) =>
    (await import('../components/CiamError')).CiamErrorRehydrator(
      // @ts-ignore
      ...args
    ),
  [getRehydratableName('LoadingSpinner')]: async (...args) =>
    (await import('../components/LoadingSpinner')).LoadingSpinner(
      // @ts-ignore
      ...args
    ),
  [getRehydratableName('ModuleList')]: async (...args) =>
    (await import('../components/ModuleList')).ModuleListRehydrator(
      // @ts-ignore
      ...args
    ),
  [getRehydratableName('MoreSupport')]: async (...args) =>
    (await import('../components/MoreSupport')).MoreSupportRehydrator(
      // @ts-ignore
      ...args
    ),
  [getRehydratableName('Announcement')]: async (...args) =>
    (await import('../components/Announcement')).AnnouncementRehydrator(
      // @ts-ignore
      ...args
    ),
  [getRehydratableName('BrowseExperienceButton')]: async (...args) =>
    (
      await import('../components/BrowseExperienceButton')
    ).BrowseExperienceButtonRehydrator(
      // @ts-ignore
      ...args
    ),
  [getRehydratableName('DownloadArticle')]: async (...args) =>
    (await import('../components/DownloadArticle')).DownloadRehydrator(
      // @ts-ignore
      ...args
    ),
  [getRehydratableName('VideoArticleList')]: async (...args) =>
    (await import('../components/VideoArticleList')).VideoArticleListRehydrator(
      // @ts-ignore
      ...args
    ),
  [getRehydratableName('ContactHub')]: async (...args) =>
    (await import('../components/ContactHub')).ContactHubRehydrator(
      // @ts-ignore
      ...args
    ),
  [getRehydratableName('StaticFormWrapper')]: async (...args) =>
    (
      await import('../components/StaticFormWrapper')
    ).StaticFormWrapperRehydrator(
      // @ts-ignore
      ...args
    ),
  [getRehydratableName('Badge')]: async (...args) =>
    (await import('../components/Badge')).BadgeRehydrator(
      // @ts-ignore
      ...args
    ),
  [getRehydratableName('PayrollTax')]: async (...args) =>
    (await import('../components/PayrollTax')).PayrollTaxRehydrator(
      // @ts-ignore
      ...args
    ),
  [getRehydratableName('SupportHours')]: async (...args) =>
    (await import('../components/SupportHours')).SupportHoursRehydrator(
      // @ts-ignore
      ...args
    ),
  [getRehydratableName('TableOfContent')]: async (...args) =>
    (await import('../components/TableOfContent')).TableOfContentRehydrator(
      // @ts-ignore
      ...args
    ),
  [getRehydratableName('CardTile')]: async (...args) =>
    (await import('../components/CardTile')).CardTileRehydrator(
      // @ts-ignore
      ...args
    ),
  [getRehydratableName('IndustryProductSelector')]: async (...args) =>
    (
      await import('../components/IndustryProductSelector')
    ).IndustryProductSelectorRehydrator(
      // @ts-ignore
      ...args
    ),

  [getRehydratableName('TitleWithSelector')]: async (...args) =>
    (
      await import('../components/TitleWithSelector')
    ).TitleWithSelectorRehydrator(
      // @ts-ignore
      ...args
    ),
};
